(() => {
  if (navigator.connection?.saveData || /(^|-)2g$/.test(navigator.connection?.effectiveType || '')) return;
  const seen = new Set();
  let timer;
  const prepare = (event) => {
    if (event.type === 'pointerover' && event.pointerType !== 'mouse') return;
    const link = event.target.closest('a[href]');
    if (!link || !link.closest('.hmg-native-header, .hmg-context-nav, #product-grid')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/^\/(collections|products)\/[^/]+$/.test(url.pathname) || url.search || url.hash || url.pathname === location.pathname || seen.has(url.href) || seen.size >= 2) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      if (seen.has(url.href) || seen.size >= 2) return;
      seen.add(url.href);
      const preload = document.createElement('link');
      preload.rel = 'prefetch';
      preload.href = url.href;
      preload.as = 'document';
      document.head.append(preload);
    }, 180);
  };
  document.addEventListener('pointerover', prepare, { passive: true });
  document.addEventListener('focusin', prepare);
  document.addEventListener('pointerout', () => clearTimeout(timer), { passive: true });
})();
